import {
  HUBSPOT_LOADER_FALLBACK_URL,
  HUBSPOT_LOADER_SCRIPT_ID,
} from "./contentBlocker";

// Injects the HubSpot loader (tracking + Conversations) once. Gated behind
// marketing consent for the always-on page tracking; also called on demand when
// the user opens support chat (a user-initiated, functional load).
export function ensureHubspotLoader(): void {
  if (document.getElementById(HUBSPOT_LOADER_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.id = HUBSPOT_LOADER_SCRIPT_ID;
  script.type = "text/javascript";
  script.async = true;
  script.defer = true;
  script.src = HUBSPOT_LOADER_FALLBACK_URL;
  document.body.appendChild(script);
}

// Tells HubSpot to drop its tracking cookies when marketing consent is withdrawn
// after the tracker already loaded. `revokeCookieConsent` (not `doNotTrack`,
// which persists in localStorage across a later re-grant) is the reversible path.
export function revokeHubspotConsent(): void {
  const w = window as unknown as { _hsq?: unknown[] };
  w._hsq = w._hsq || [];
  w._hsq.push(["revokeCookieConsent"]);
}
